import { render, staticRenderFns } from "./listaSolicitudBajas.vue?vue&type=template&id=507249f8&"
import script from "./listaSolicitudBajas.vue?vue&type=script&lang=js&"
export * from "./listaSolicitudBajas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports